<template>
  <div
    @mouseover="mouseEnter = true"
    @mouseleave="mouseEnter = false"
    :class="[{ 'mouse-enter': mouseEnter, 'mouse-leave': !mouseEnter }]"
  >
    <dropdown-menu
      id="drop-requests"
      v-model="show"
      :right="false"
      :hover="false"
      :hover_time="hoverTime"
      :closeOnClickOutside="false"
      transition="translate-fade-down"
    >
      <div class="request-content">
        <div class="request-content-dropdown">
          <div v-if="(item.status === 0)">
            <md-icon class="icon-margin-request" :class="getColorIcon">{{
              requestIcon
            }}</md-icon>
          </div>
          <div v-if="(item.status != 0)">
            <md-icon class="icon-margin-request icon-color-primary">{{
              "mood"
            }}</md-icon>
          </div>
          <h5 :class="getTextColor" v-if="!requestFromUser && (item.status === 0)">{{ requestsText }}</h5>
          <h5 class="text-color-primary" v-if="(item.status != 0) && !requestFromUser">{{  createdTextFromType }}</h5>
          <md-button
            :md-ripple="false"
            md-elevation="0"
            class="md-icon-button dropdown-toggle menu-hamburguer"
            data-cy="itemDetailsRequests"
          >
            <md-icon class="icon-margin-request" v-if="show"
              >arrow_drop_up</md-icon
            >
            <md-icon class="icon-margin-request" v-if="!show"
              >arrow_drop_down</md-icon
            >
          </md-button>
        </div>

        <div class="request-content-box">
          <ItemReceivedSentStatus :item="activity" :acceptedRequest="acceptedRequest" />
        </div>
      </div>

      <div
        slot="dropdown"
        class="my-drop"
        :class="[
          { 'slide-top': animationIn },
          { 'slide-bck-bottom': animationOut },
        ]"
      >
        <div
          v-for="(request, index) in item.requests"
          :key="index"
          ref="requests"
        >
          <SItemRequest
            id="item-request"
            :request="request"
            :points="points"
            :cash="cash"
            class="mb-1"
            :item="item"
            :ref="request.id"
            v-if="(item.status === 0)"
          />
          <SItemRequest
            id="item-request"
            :request="request"
            :points="points"
            :cash="cash"
            class="mb-1"
            :item="item"
            :ref="request.id"
            v-if="((request.situation === 1) || (request.situation === 2) || (request.situation === 3)) && (item.status != 0)"
          />
          <SItemRequestFromUser
            id="item-request"
            :request="itemRequests"
            :points="points"
            :cash="cash"
            class="mb-1"
            :item="item"
            :ref="itemRequests.id"
            v-if="requestFromUser"
          />
        </div>
      </div>
    </dropdown-menu>
  </div>
</template>

<script>
import SItemRequest from "@/material-components/atoms/SItemRequest";
import SItemRequestFromUser from "@/material-components/atoms/SItemRequestFromUser";
import DropdownMenu from "@innologica/vue-dropdown-menu";
import itemType from "@/enum/item-type";
import ItemHelperVue from "../../mixins/ItemHelper.vue";
import UserHelperVue from "../../mixins/UserHelper.vue";
import requestSituation from "@/enum/request-situation";
import itemStatus from "@/enum/item-status";
import ItemReceivedSentStatus from "@/components/molecules/ItemReceivedSentStatus";

export default {
  name: "SItemRequestsDropdown",
  props: [
    "requestsText",
    "requestIcon",
    "mainColor",
    "itemRequests",
    "points",
    "cash",
    "item",
    "itemHaveRequests",
    "requestFromUser",
  ],
  mixins: [ItemHelperVue, UserHelperVue],
  data() {
    return {
      mouseEnter: false,
      show: false,
      hoverTime: 500,
      animationIn: false,
      animationOut: false,
    };
  },
  methods: {
    dropdownAction(e) {
      e.preventDefault();
      e.stopImmediatePropagation();
      if (this.itemHaveRequests === true) {
        if (this.show) {
          this.animationIn = false;
          this.animationOut = true;
          setTimeout(() => {
            this.show = false;
          }, 500);
        } else {
          this.animationIn = true;
          this.animationOut = false;
          this.show = true;
        }
      }
    },
    setRequestAsAccepted(requestId) {
      this.$refs[requestId][0].setRequestAsAccepted();
    },
    setAllRequestsAsRejected() {
      for (let request of this.itemRequests) {
        if (this.$refs[request.id][0].accept_state !== "ACCEPTED") {
          this.$refs[request.id][0].setRequestAsRejected();
        }
      }
    },
    setModalTitle() {
      if (this.item.type !== undefined) {
        let type = this.item.type;
        if (type === itemType.GIVE || type === itemType.LEND) {
          this.$emit("accept-request");
        } else if (type === itemType.RECEIVE || type === itemType.BORROW) {
          this.$emit("accept-offer");
        }
      }
    },
    setUpdated(dueDate) {
      let updated = new Date();
      if (this.item.changeSituationAt) {
        updated = new Date(this.item.changeSituationAt);
        updated.setDate(updated.getDate() + dueDate);
      }

      return updated;
    }
  },
  components: {
    DropdownMenu,
    SItemRequest,
    SItemRequestFromUser,
    ItemReceivedSentStatus
  },
  computed: {
    getTextColor() {
      switch (this.mainColor) {
        case "disabled":
          return "text-color-disabled";
        case "primary":
          return "text-color-primary";
        default:
          return "";
      }
    },
    getColorIcon() {
      switch (this.mainColor) {
        case "disabled":
          return "icon-color-disabled";
        case "primary":
          return "icon-color-primary";
        default:
          return "";
      }
    },
    createdTextFromType() {
      switch (this.item.type) {
        case itemType.GIVE:
          return "You accepted a request".toUpperCase();
        case itemType.RECEIVE:
          return "You accepted an offer".toUpperCase();
        case itemType.LEND:
          return "You accepted a request".toUpperCase();
        case itemType.BORROW:
          return "You accepted an offer".toUpperCase();
        default:
          return "Type not identified".toUpperCase()
      }
    },
    activity() {
      return {
        ...this.item,
        user: this.loggedUser
      }
    },
    setDueDate() {
      let dueDate;

      if (this.activity.type === itemType.RECEIVE || this.activity.type === itemType.BORROW) {
        dueDate = this.activity.posterId === this.loggedUser.id ? 20 : 10;

      } else {
        dueDate = this.activity.posterId === this.loggedUser.id ? 10 : 20;
      }

      return dueDate;
    },
    acceptedRequest() {
      let d = new Date();
      let dueDate = 0;
      let updated = new Date();

      if (this.activity.requests?.length) {
        let result = {};

        result = this.activity.requests.find((request) => {
          dueDate = this.setDueDate;

          if (request.changeSituationAt) {
            updated = new Date(request.changeSituationAt);
            updated.setDate(updated.getDate() + dueDate);
          }

          return (
            request.situation === requestSituation.ACCEPTED &&
            (d > updated ||
              this.activity.status === itemStatus.NOT_SENT ||
              this.activity.status === itemStatus.NOT_RECEIVED)
          );
        });
        result = result ? result : {};

        return result;
      } else if (
        this.item.situation === requestSituation.ACCEPTED && (this.activity.status === itemStatus.IDLE || this.activity.posterId !== this.loggedUser.id)
      ) {
        dueDate = this.setDueDate;

        updated = this.setUpdated(dueDate)
        let result = {};
        if (
          d > updated ||
          this.activity.status === itemStatus.NOT_SENT ||
          this.activity.status === itemStatus.NOT_RECEIVED
        ) {
          result = this.item;
        }
        return result;
      } else {
        return {};
      }
    },
    isTradeCompleted() {
      return this.item.status === this.itemStatus.RECEIVED;
    },
  },
  mounted() {
    if (this.itemHaveRequests && this.$route.query.interested) {
      this.show = true;
    }
  },
};
</script>

<style lang="scss">
#drop-requests .show {
  position: inherit !important;
  width: 100% !important;
  z-index: 1 !important;
  margin-bottom: 0 !important;
  border: none;
  display: flex;
  flex-direction: column;
  align-content: center;
  align-items: center;
  background-color: white;
}
.my-drop {
  width: 100%;
}
.request-content {
  width: 100%;

  display: flex;
  justify-content: space-evenly;
  align-items: center;
}

.request-content-dropdown {
  width: 100%;
  cursor: pointer;
  display: flex;
  justify-content: center;
  align-items: center;
  padding-left: 20%;
}

.request-content-box{
  width: 25%;
  padding: 1rem;
}

.icon-margin-request {
  margin-bottom: 0.69rem;
  margin-right: 0.5rem;
  color: $black !important;
}

/* This css removes the background color of the md button */
#drop-requests .md-button:not([disabled]).md-ripple-off:active:before {
  opacity: 0 !important;
}
#drop-requests .md-button:not([disabled]):hover:before {
  opacity: 0 !important;
}
</style>

<style lang="scss" scoped>
.text-color-primary,
.icon-color-primary {
  color: $primary !important;
}
.text-color-disabled,
.icon-color-disabled {
  color: $grey !important;
}

.md-icon-button {
  pointer-events: unset !important;
  cursor: pointer !important;
}
</style>

<style lang="scss" scoped>
/* Responsiveness requests */
@media screen and (max-width: 768px) {
}
</style>

<style lang="scss">

#item-request .user-info-xxsmal {
  display: none;
}
@media screen and (min-width: 509px) {
  #item-request .user-info-xxsmal {
    display: none;
  }
}
@media screen and (max-width: 768px) {
  #item-request .user-payment-info {
    font-size: 12px;
  }
  #item-request .payment-value {
    margin: 0;
  }
  #item-request .user-payment {
    flex-direction: column;
    justify-content: center;
    place-content: center;
    align-items: center;
  }
}
@media screen and (min-width: 500px) {
  #item-request .user-payment-info-mobile {
    display: none;
  }
}
@media screen and (max-width: 499px) {
  #item-request .user-payment-info {
    display: none;
  }
}
</style>

<style lang="scss" scoped>
/* Animation card */
.slide-top {
  -webkit-animation: slide-top 0.8s cubic-bezier(0.68, -0.55, 0.265, 1.55) both;
  animation: slide-top 0.8s cubic-bezier(0.68, -0.55, 0.265, 1.55) both;
  width: 95%;
}
@-webkit-keyframes slide-top {
  0% {
    -webkit-transform: translateY(100px);
    transform: translateY(100px);
  }
  100% {
    -webkit-transform: translateY(0px);
    transform: translateY(0px);
  }
}
@keyframes slide-top {
  0% {
    -webkit-transform: translateY(100px);
    transform: translateY(100px);
  }
  100% {
    -webkit-transform: translateY(0px);
    transform: translateY(0px);
  }
}
.slide-bck-bottom {
  -webkit-animation: slide-bck-bottom 0.8s
    cubic-bezier(0.68, -0.55, 0.265, 1.55) both;
  animation: slide-bck-bottom 0.8s cubic-bezier(0.68, -0.55, 0.265, 1.55) both;
}
@-webkit-keyframes slide-bck-bottom {
  0% {
    -webkit-transform: translateZ(0) translateY(0);
    transform: translateZ(0) translateY(0);
  }
  100% {
    -webkit-transform: translateZ(0) translateY(100px);
    transform: translateZ(0) translateY(100px);
  }
}
@keyframes slide-bck-bottom {
  0% {
    -webkit-transform: translateZ(0) translateY(0);
    transform: translateZ(0) translateY(0);
  }
  100% {
    -webkit-transform: translateZ(0) translateY(100px);
    transform: translateZ(0) translateY(100px);
  }
}
</style>
